const DEFAULT_STORAGE_KEY = 'features';

function getStorageKey(): string {
    return process.env.FEATURES_STORAGE_KEY || DEFAULT_STORAGE_KEY;
}

export const getFeaturesFromStorage = (): Record<string, unknown> => {
    const storageItem = localStorage.getItem(getStorageKey());
    if (!storageItem) {
        return {};
    }
    return JSON.parse(storageItem);
};

export const clearFeaturesStorage = (): void => {
    localStorage.removeItem(getStorageKey());
};

export const setFeaturesToStorage = (features?: Record<string, unknown>): void => {
    clearFeaturesStorage();

    if (!features || Object.keys(features).length === 0) {
        return;
    }
    localStorage.setItem(getStorageKey(), JSON.stringify(features));
};
